export default {
    setLoading(state, loading)
    {
        state.loading = loading;
    },
    setPayouts(state, {payouts})
    {
        state.payouts = payouts.data;
        state.total = payouts.total;
    }
}
